import { MonitorOutlined } from "@ant-design/icons";
import { Tag, Typography, Tooltip, theme } from "antd";
import React from "react";
import { CustomTooltip } from "src/components/CustomTooltip";
import { DatabaseIcon } from "src/components/DatabaseIcon";

interface RecordsAnalyzedTagProps {
  processedRecords?: number;
  totalRecords?: number;
  style?: React.CSSProperties;
  variant?: "tag" | "text";
}

export const RecordsAnalyzedTag: React.FC<RecordsAnalyzedTagProps> = ({
  processedRecords,
  totalRecords,
  style,
  variant = "tag",
}) => {
  if (processedRecords === undefined || totalRecords === undefined) return null;
  const content = (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        gap: 4,
      }}
    >
      <DatabaseIcon style={{ color: "var(--color-foreground-tertiary)" }} />
      <Typography.Text className="vzbl-text-2">
        {processedRecords} records
      </Typography.Text>
    </div>
  );
  const tooltipContent = `Analyzed ${processedRecords} of ${totalRecords} records`;

  if (variant === "text") {
    return (
      <CustomTooltip content={tooltipContent}>
        <Typography.Text className="vzbl-text-3 vzbl-clamp-1-line">
          {content}
        </Typography.Text>
      </CustomTooltip>
    );
  }
  return (
    <CustomTooltip content={tooltipContent}>
      <Tag style={{ marginTop: 8, ...style }}>{content}</Tag>
    </CustomTooltip>
  );
};
